import { IonCol, IonIcon, IonItem, IonRow, IonSelect, IonSelectOption } from "@ionic/react"
import { star, starOutline } from "ionicons/icons"
import { useEffect, useState } from "react"
import AE2Input from "../../elements/AE2Input"


interface Props{
    setParentForm:Function
    formErrors:[errors:any,setErrors:Function]
}

const startingForm = {
totalGrossFloorArea : "",
totalGrossFloorArea_units : "",
totalGrossFloorArea_date : "",
licensedBedCapacity : "",
licensedBedCapacity_date : "",
numberOfResidentialLivingUnits : "",
numberOfResidentialLivingUnits_date : "",
averageNumberOfResidents : "",
averageNumberOfResidents_date : "",
numberOfWorkers : "",
numberOfWorkers_date : "",
maximumResidentCapacity:"",
maximumResidentCapacity_date:"",
numberOfComputers:"",
numberOfComputers_date:"",
numberOfCommercialRefrigerationUnits:"",
numberOfCommercialRefrigerationUnits_date:"",
numberOfCommercialWashingMachines:"",
numberOfCommercialWashingMachines_date:"",
numberOfResidentialWashingMachines:"",
numberOfResidentialWashingMachines_date:"",
numberOfResidentialLiftSystems:"",
numberOfResidentialLiftSystems_date:"",
percentCooled : "",
percentCooled_date : "",
percentHeated : "",
percentHeated_date : ""
}


const startErrors = {
totalGrossFloorArea : "Field Required",
totalGrossFloorArea_units : "Select Units",
totalGrossFloorArea_date : "Date is required",
licensedBedCapacity : "",
licensedBedCapacity_date : "",
numberOfResidentialLivingUnits : "",
numberOfResidentialLivingUnits_date : "",
averageNumberOfResidents : "",
averageNumberOfResidents_date : "",
numberOfWorkers : "",
numberOfWorkers_date : "",
maximumResidentCapacity:"",
maximumResidentCapacity_date:"",
numberOfComputers:"",
numberOfComputers_date:"",
numberOfCommercialRefrigerationUnits:"",
numberOfCommercialRefrigerationUnits_date:"",
numberOfCommercialWashingMachines:"",
numberOfCommercialWashingMachines_date:"",
numberOfResidentialWashingMachines:"",
numberOfResidentialWashingMachines_date:"",
numberOfResidentialLiftSystems:"",
numberOfResidentialLiftSystems_date:"",
percentCooled : "",
percentCooled_date : "",
percentHeated : "",
percentHeated_date : ""
}

const SeniorLiving: React.FC<Props> = ({setParentForm,formErrors}) => {
    const [form, setForm] = useState(startingForm)
    const [errors, setErrors] = formErrors
    const handleFormChange = (value:any,name:string) => {
        validate(name,value)
        setForm((prevState) => {
            return {
                ...prevState,
                [name]:value
            }
        } )
        setParentForm({...form, [name]:value},'form')

    }

    const handleError = (name:string,value:any) => {
        setErrors((prevState:any) => {
            return {
                ...prevState,
                [name]:value
            }
        } )

    }

    const getCurrentDate = () => {
        return new Date().getTime();
      };


    useEffect(()=>{
        setErrors((prevState:any) => {
            return {
                ...prevState,
                ...startErrors
            }
        } )
    }, [setErrors])
    const validate = (name:string, value:any) => {
        switch(name){
            case ('totalGrossFloorArea'):
                if (value === ''){
                    handleError('totalGrossFloorArea','Gross Floor Are Cannot be Empty')
                }
                else if (value < 0){
                    handleError('totalGrossFloorArea','GFA must be a positive number')
                }
                else {
                    handleError('totalGrossFloorArea','')
                }
                break;
            case ('totalGrossFloorArea_units'):
                if (value === ''){
                    handleError('totalGrossFloorArea_units','Select gfa units')
                }
                else {
                    handleError('totalGrossFloorArea_units','')
                }
                break;
            case ('totalGrossFloorArea_date'):
                if (value === ''){
                    handleError('totalGrossFloorArea_date','Date cannot be empty')
                }
                else if (new Date(value).getTime() > getCurrentDate()){
                    handleError('totalGrossFloorArea_date','Invalid Date')
                }
                else {
                    handleError('totalGrossFloorArea_date','')
                }
                break;
            case('licensedBedCapacity'):
                if(value !==''){
                    form.licensedBedCapacity_date === '' ? handleError('licensedBedCapacity_date','Date cannot be empty') : handleError('licensedBedCapacity_date','')
                    value < 0 ? handleError('licensedBedCapacity','Must be a Positive number') : handleError('licensedBedCapacity','')
                }
                else{
                    handleError('licensedBedCapacity','')
                    handleError('licensedBedCapacity_date','')
                }
                break;
            case('licensedBedCapacity_date'):
                if(value !==''){
                    form.licensedBedCapacity === '' ? handleError('licensedBedCapacity','Field cannot be empty') : handleError('licensedBedCapacity','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('licensedBedCapacity_date','Invalid Date') : handleError('licensedBedCapacity_date','')
                }
                else{
                    handleError('licensedBedCapacity','')
                    handleError('licensedBedCapacity_date','')
                }
                break;
            case('numberOfResidentialLivingUnits'):
                if(value !==''){
                    form.numberOfResidentialLivingUnits_date === '' ? handleError('numberOfResidentialLivingUnits_date','Date cannot be empty') : handleError('numberOfResidentialLivingUnits_date','')
                    value < 0 ? handleError('numberOfResidentialLivingUnits','Must be a Positive number') : handleError('numberOfResidentialLivingUnits','')
                }
                else{
                    handleError('numberOfResidentialLivingUnits','')
                    handleError('numberOfResidentialLivingUnits_date','')
                }
                break;
            case('numberOfResidentialLivingUnits_date'):
                if(value !==''){
                    form.numberOfResidentialLivingUnits === '' ? handleError('numberOfResidentialLivingUnits','Field cannot be empty') : handleError('numberOfResidentialLivingUnits','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('numberOfResidentialLivingUnits_date','Invalid Date') : handleError('numberOfResidentialLivingUnits_date','')
                }
                else{
                    handleError('numberOfResidentialLivingUnits','')
                    handleError('numberOfResidentialLivingUnits_date','')
                }
                break;
            case('averageNumberOfResidents'):
                if(value !==''){
                    form.averageNumberOfResidents_date === '' ? handleError('averageNumberOfResidents_date','Date cannot be empty') : handleError('averageNumberOfResidents_date','')
                    value < 0 ? handleError('averageNumberOfResidents','Must be a Positive number') : handleError('averageNumberOfResidents','')
                }
                else{
                    handleError('averageNumberOfResidents','')
                    handleError('averageNumberOfResidents_date','')
                }
                break;
            case('averageNumberOfResidents_date'):
                if(value !==''){
                    form.averageNumberOfResidents === '' ? handleError('averageNumberOfResidents','Field cannot be empty') : handleError('averageNumberOfResidents','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('averageNumberOfResidents_date','Invalid Date') : handleError('averageNumberOfResidents_date','')
                }
                else{
                    handleError('averageNumberOfResidents','')
                    handleError('averageNumberOfResidents_date','')
                }
                break;
            case('numberOfWorkers'):
                if(value !==''){
                    form.numberOfWorkers_date === '' ? handleError('numberOfWorkers_date','Date cannot be empty') : handleError('numberOfWorkers_date','')
                    value < 0 ? handleError('numberOfWorkers','Must be a Positive number') : handleError('numberOfWorkers','')
                }
                else{
                    handleError('numberOfWorkers','')
                    handleError('numberOfWorkers_date','')
                }
                break;
            case('numberOfWorkers_date'):
                if(value !==''){
                    form.numberOfWorkers === '' ? handleError('numberOfWorkers','Field cannot be empty') : handleError('numberOfWorkers','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('numberOfWorkers_date','Invalid Date') : handleError('numberOfWorkers_date','')
                }
                else{
                    handleError('numberOfWorkers','')
                    handleError('numberOfWorkers_date','')
                }
                break;
            case('maximumResidentCapacity'):
                if(value !==''){
                    form.maximumResidentCapacity_date === '' ? handleError('maximumResidentCapacity_date','Date cannot be empty') : handleError('maximumResidentCapacity_date','')
                    value < 0 ? handleError('maximumResidentCapacity','Must be a Positive number') : handleError('maximumResidentCapacity','')
                }
                else{
                    handleError('maximumResidentCapacity','')
                    handleError('maximumResidentCapacity_date','')
                }
                break;
            case('maximumResidentCapacity_date'):
                if(value !==''){
                    form.maximumResidentCapacity === '' ? handleError('maximumResidentCapacity','Field cannot be empty') : handleError('maximumResidentCapacity','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('maximumResidentCapacity_date','Invalid Date') : handleError('maximumResidentCapacity_date','')
                }
                else{
                    handleError('maximumResidentCapacity','')
                    handleError('maximumResidentCapacity_date','')
                }
                break;
            case('numberOfComputers'):
                if(value !==''){
                    form.numberOfComputers_date === '' ? handleError('numberOfComputers_date','Date cannot be empty') : handleError('numberOfComputers_date','')
                    value < 0 ? handleError('numberOfComputers','Must be a Positive number') : handleError('numberOfComputers','')
                }
                else{
                    handleError('numberOfComputers','')
                    handleError('numberOfComputers_date','')
                }
                break;
            case('numberOfComputers_date'):
                if(value !==''){
                    form.numberOfComputers === '' ? handleError('numberOfComputers','Field cannot be empty') : handleError('numberOfComputers','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('numberOfComputers_date','Invalid Date') : handleError('numberOfComputers_date','')
                }
                else{
                    handleError('numberOfComputers','')
                    handleError('numberOfComputers_date','')
                }
                break;
            case('numberOfCommercialRefrigerationUnits'):
                if(value !==''){
                    form.numberOfCommercialRefrigerationUnits_date === '' ? handleError('numberOfCommercialRefrigerationUnits_date','Date cannot be empty') : handleError('numberOfCommercialRefrigerationUnits_date','')
                    value < 0 ? handleError('numberOfCommercialRefrigerationUnits','Must be a Positive number') : handleError('numberOfCommercialRefrigerationUnits','')
                }
                else{
                    handleError('numberOfCommercialRefrigerationUnits','')
                    handleError('numberOfCommercialRefrigerationUnits_date','')
                }
                break;
            case('numberOfCommercialRefrigerationUnits_date'):
                if(value !==''){
                    form.numberOfCommercialRefrigerationUnits === '' ? handleError('numberOfCommercialRefrigerationUnits','Field cannot be empty') : handleError('numberOfCommercialRefrigerationUnits','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('numberOfCommercialRefrigerationUnits_date','Invalid Date') : handleError('numberOfCommercialRefrigerationUnits_date','')
                }
                else{
                    handleError('numberOfCommercialRefrigerationUnits','')
                    handleError('numberOfCommercialRefrigerationUnits_date','')
                }
                break;
            case('numberOfCommercialWashingMachines'):
                if(value !==''){
                    form.numberOfCommercialWashingMachines_date === '' ? handleError('numberOfCommercialWashingMachines_date','Date cannot be empty') : handleError('numberOfCommercialWashingMachines_date','')
                    value < 0 ? handleError('numberOfCommercialWashingMachines','Must be a Positive number') : handleError('numberOfCommercialWashingMachines','')
                }
                else{
                    handleError('numberOfCommercialWashingMachines','')
                    handleError('numberOfCommercialWashingMachines_date','')
                }
                break;
            case('numberOfCommercialWashingMachines_date'):
                if(value !==''){
                    form.numberOfCommercialWashingMachines === '' ? handleError('numberOfCommercialWashingMachines','Field cannot be empty') : handleError('numberOfCommercialWashingMachines','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('numberOfCommercialWashingMachines_date','Invalid Date') : handleError('numberOfCommercialWashingMachines_date','')
                }
                else{
                    handleError('numberOfCommercialWashingMachines','')
                    handleError('numberOfCommercialWashingMachines_date','')
                }
                break;
            case('numberOfResidentialWashingMachines'):
                if(value !==''){
                    form.numberOfResidentialWashingMachines_date === '' ? handleError('numberOfResidentialWashingMachines_date','Date cannot be empty') : handleError('numberOfResidentialWashingMachines_date','')
                    value < 0 ? handleError('numberOfResidentialWashingMachines','Must be a Positive number') : handleError('numberOfResidentialWashingMachines','')
                }
                else{
                    handleError('numberOfResidentialWashingMachines','')
                    handleError('numberOfResidentialWashingMachines_date','')
                }
                break;
            case('numberOfResidentialWashingMachines_date'):
                if(value !==''){
                    form.numberOfResidentialWashingMachines === '' ? handleError('numberOfResidentialWashingMachines','Field cannot be empty') : handleError('numberOfResidentialWashingMachines','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('numberOfResidentialWashingMachines_date','Invalid Date') : handleError('numberOfResidentialWashingMachines_date','')
                }
                else{
                    handleError('numberOfResidentialWashingMachines','')
                    handleError('numberOfResidentialWashingMachines_date','')
                }
                break;
            case('numberOfResidentialLiftSystems'):
                if(value !==''){
                    form.numberOfResidentialLiftSystems_date === '' ? handleError('numberOfResidentialLiftSystems_date','Date cannot be empty') : handleError('numberOfResidentialLiftSystems_date','')
                    value < 0 ? handleError('numberOfResidentialLiftSystems','Must be a Positive number') : handleError('numberOfResidentialLiftSystems','')
                }
                else{
                    handleError('numberOfResidentialLiftSystems','')
                    handleError('numberOfResidentialLiftSystems_date','')
                }
                break;
            case('numberOfResidentialLiftSystems_date'):
                if(value !==''){
                    form.numberOfResidentialLiftSystems === '' ? handleError('numberOfResidentialLiftSystems','Field cannot be empty') : handleError('numberOfResidentialLiftSystems','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('numberOfResidentialLiftSystems_date','Invalid Date') : handleError('numberOfResidentialLiftSystems_date','')
                }
                else{
                    handleError('numberOfResidentialLiftSystems','')
                    handleError('numberOfResidentialLiftSystems_date','')
                }
                break;
            case('percentCooled'):
                if(value !==''){
                    form.percentCooled_date === '' ? handleError('percentCooled_date','Date cannot be empty') : handleError('percentCooled_date','')

                }
                else{
                    handleError('percentCooled','')
                    handleError('percentCooled_date','')
                }
                break;
            case('percentCooled_date'):
                if(value !==''){
                    form.percentCooled === '' ? handleError('percentCooled','Field cannot be empty') : handleError('percentCooled','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('percentCooled_date','Invalid Date') : handleError('percentCooled_date','')
                }
                else{
                    handleError('percentCooled','')
                    handleError('percentCooled_date','')
                }
                break;
            case('percentHeated'):
                if(value !==''){
                    form.percentHeated_date === '' ? handleError('percentHeated_date','Date cannot be empty') : handleError('percentHeated_date','')

                }
                else{
                    handleError('percentHeated','')
                    handleError('percentHeated_date','')
                }
                break;
            case('percentHeated_date'):
                if(value !==''){
                    form.percentHeated === '' ? handleError('percentHeated','Field cannot be empty') : handleError('percentHeated','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('percentHeated_date','Invalid Date') : handleError('percentHeated_date','')
                }
                else{
                    handleError('percentHeated','')
                    handleError('percentHeated_date','')
                }
                break;
            default:
                break;
        }
    }

    return(
        <div className="text-dark-blue">
            <h1>Senior Living Community Form</h1>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input type="number" errorText={errors.totalGrossFloorArea}  value={form.totalGrossFloorArea} placeholder='GFA' onIonInput={e => (handleFormChange(e.detail.value!,'totalGrossFloorArea'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Total Gross Floor Area:</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                    <div style={{width:'100%'}}>
                        <IonSelect label="Units" className={errors.totalGrossFloorArea_units === '' ? "valid":'invalid'} value={form.totalGrossFloorArea_units} interface='popover' placeholder='Units' onIonChange={e => (handleFormChange(e.detail.value!,'totalGrossFloorArea_units'))}>
                            <IonSelectOption value={'Square Feet'}>Square Feet</IonSelectOption>
                            <IonSelectOption value={'Square Meters'}>Square Meters</IonSelectOption>
                        </IonSelect>
                        <div className="error-detail">{errors.totalGrossFloorArea_units}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.totalGrossFloorArea_date} value={form.totalGrossFloorArea_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'totalGrossFloorArea_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input labelPlacement="stacked" type="number" errorText={errors.numberOfResidentialLivingUnits}  value={form.numberOfResidentialLivingUnits} placeholder='# Residential Living Units' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfResidentialLivingUnits'))}>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Number of Residential Living Units</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.numberOfResidentialLivingUnits_date}  value={form.numberOfResidentialLivingUnits_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfResidentialLivingUnits_date'))}>
                        </AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input labelPlacement="stacked" type="number" errorText={errors.averageNumberOfResidents}  value={form.averageNumberOfResidents} placeholder='Average Number of Residents' onIonInput={e => (handleFormChange(e.detail.value!,'averageNumberOfResidents'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Average Number of Resident</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.averageNumberOfResidents_date}  value={form.averageNumberOfResidents_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'averageNumberOfResidents_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input type="number" errorText={errors.numberOfWorkers}  value={form.numberOfWorkers} placeholder='# Workers' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfWorkers'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Number of Workers</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.numberOfWorkers_date}  value={form.numberOfWorkers_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfWorkers_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input type="number" errorText={errors.maximumResidentCapacity}  value={form.maximumResidentCapacity} placeholder='Maximum Resident Capacity' onIonInput={e => (handleFormChange(e.detail.value!,'maximumResidentCapacity'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Maximum Resident Capacity</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.maximumResidentCapacity_date}  value={form.maximumResidentCapacity_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'maximumResidentCapacity_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input type="number" errorText={errors.numberOfComputers}  value={form.numberOfComputers} placeholder='# Computers' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfComputers'))}>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Number of Computers</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.numberOfComputers_date}  value={form.numberOfComputers_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfComputers_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input type="number" errorText={errors.numberOfCommercialRefrigerationUnits}  value={form.numberOfCommercialRefrigerationUnits} placeholder='# Commercial Refrigeration Units' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfCommercialRefrigerationUnits'))}>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Number of Commercial Refrigeration/Freezer Units</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.numberOfCommercialRefrigerationUnits_date}  value={form.numberOfCommercialRefrigerationUnits_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfCommercialRefrigerationUnits_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input labelPlacement="stacked" type="number" errorText={errors.numberOfCommercialWashingMachines}  value={form.numberOfCommercialWashingMachines} placeholder='# Commercial-type Washing Machines' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfCommercialWashingMachines'))}>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> number od Commercial-Type Washing Machines</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.numberOfCommercialWashingMachines_date}  value={form.numberOfCommercialWashingMachines_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfCommercialWashingMachines_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input labelPlacement="stacked" type="number" errorText={errors.numberOfResidentialWashingMachines}  value={form.numberOfResidentialWashingMachines} placeholder='# Residential Washing Machines' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfResidentialWashingMachines'))}>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Number of Residential Washing Machines</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.numberOfResidentialWashingMachines_date}  value={form.numberOfResidentialWashingMachines_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfResidentialWashingMachines_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input labelPlacement="stacked" type="number" errorText={errors.numberOfResidentialLiftSystems}  value={form.numberOfResidentialLiftSystems} placeholder='# Residential Electronic Lift System' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfResidentialLiftSystems'))}>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Number of Residential Electronic Lift Systems</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.numberOfResidentialLiftSystems_date}  value={form.numberOfResidentialLiftSystems_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfResidentialLiftSystems_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>

            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                    <div style={{width:'100%'}}>
                        <IonSelect className={errors.percentCooled === '' ? "valid":'invalid'}  value={form.percentCooled} interface='popover' placeholder='Percent Cooled' onIonChange={e => (handleFormChange(e.detail.value!,'percentCooled'))}>
                            <IonSelectOption>0</IonSelectOption>
                            <IonSelectOption>10</IonSelectOption>
                            <IonSelectOption>20</IonSelectOption>
                            <IonSelectOption>30</IonSelectOption>
                            <IonSelectOption>40</IonSelectOption>
                            <IonSelectOption>50</IonSelectOption>
                            <IonSelectOption>60</IonSelectOption>
                            <IonSelectOption>70</IonSelectOption>
                            <IonSelectOption>80</IonSelectOption>
                            <IonSelectOption>90</IonSelectOption>
                            <IonSelectOption>100</IonSelectOption>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Percent Cooled</div>
                        </IonSelect>
                        <div className="error-detail">{errors.percentCooled}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4" >
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.percentCooled_date}  value={form.percentCooled_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'percentCooled_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                    <div style={{width:'100%'}}>
                        <IonSelect className={errors.percentHeated === '' ? "valid":'invalid'}  value={form.percentHeated} interface='popover' placeholder='Percent Heated' onIonChange={e => (handleFormChange(e.detail.value!,'percentHeated'))}>
                            <IonSelectOption>0</IonSelectOption>
                            <IonSelectOption>10</IonSelectOption>
                            <IonSelectOption>20</IonSelectOption>
                            <IonSelectOption>30</IonSelectOption>
                            <IonSelectOption>40</IonSelectOption>
                            <IonSelectOption>50</IonSelectOption>
                            <IonSelectOption>60</IonSelectOption>
                            <IonSelectOption>70</IonSelectOption>
                            <IonSelectOption>80</IonSelectOption>
                            <IonSelectOption>90</IonSelectOption>
                            <IonSelectOption>100</IonSelectOption>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Percent Heated</div>
                        </IonSelect>
                        <div className="error-detail">{errors.percentHeated}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4" >
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.percentHeated_date}  value={form.percentHeated_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'percentHeated_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input type="number" errorText={errors.licensedBedCapacity}  value={form.licensedBedCapacity} placeholder='Licensed Bed Capacity' onIonInput={e => (handleFormChange(e.detail.value!,'licensedBedCapacity'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Licensed Bed Capacity</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.licensedBedCapacity_date}  value={form.licensedBedCapacity_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'licensedBedCapacity_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
        </div>
    )
}

export default SeniorLiving